import styled from 'styled-components'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'

export const RenameModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  gap: 0.5rem;
  padding: 1rem;
`

export const RenameModalOldNameContainer = styled.div`
  padding: 0 1.5rem;
`

export const RenameModalNewNameContainer = styled.div`
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  background: ${colorsOptions.greys.white};
`
